if (!customElements.get('cart-terms-consent')) {
  customElements.define(
    'cart-terms-consent',
    class CartTermsConsent extends HTMLElement {
      connectedCallback() {
        this.checkbox = this.querySelector('input[type="checkbox"]');
        this.error = this.querySelector('[role="alert"]');

        if (!this.checkbox) return;

        this.form = document.getElementById(this.checkbox.getAttribute('form'));
        const acceleratedCheckoutId = this.dataset.acceleratedCheckoutId;
        this.acceleratedCheckout = acceleratedCheckoutId
          ? document.querySelector(`[data-cart-terms-accelerated="${acceleratedCheckoutId}"]`)
          : null;

        this.handleChange = this.handleChange.bind(this);
        this.handleInvalid = this.handleInvalid.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

        this.checkbox.addEventListener('change', this.handleChange);
        this.checkbox.addEventListener('invalid', this.handleInvalid);
        this.form?.addEventListener('submit', this.handleSubmit);
        this.updateState();
      }

      disconnectedCallback() {
        this.checkbox?.removeEventListener('change', this.handleChange);
        this.checkbox?.removeEventListener('invalid', this.handleInvalid);
        this.form?.removeEventListener('submit', this.handleSubmit);
      }

      handleChange() {
        this.updateState();
      }

      handleInvalid() {
        if (this.error) this.error.hidden = false;
      }

      handleSubmit(event) {
        if (this.checkbox.checked) return;

        event.preventDefault();
        if (this.error) this.error.hidden = false;
        this.checkbox.focus();
        this.checkbox.reportValidity();
      }

      updateState() {
        const accepted = this.checkbox.checked;
        if (this.error) this.error.hidden = accepted;

        if (this.acceleratedCheckout) {
          this.acceleratedCheckout.hidden = !accepted;
          this.acceleratedCheckout.setAttribute('aria-hidden', String(!accepted));
        }
      }
    }
  );
}
